<template>
  <div class="home">
    <v-row>
      <v-carousel cycle
        height="600px"
        hide-delimiter-background
        show-arrows-on-hover>
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          :src="item.src"
          gradient="to top right, rgba(0,0,0,.60), rgba(0,0,0,.60)"
        >
        <v-row
          justify="center"
          style="color:white; margin-top: 450px"
        >
          <div class="display-2">{{ item.title }}</div>
        </v-row>
        <v-row
          class="fill-height"
          justify="center"
          style="color:white;"
        >
          <div class="display-1">{{ item.text }}</div>
        </v-row>
      </v-carousel-item>
      </v-carousel>
    </v-row>
    <v-row align="center" justify="center" style="padding-top: 10em;">
      <v-container>
        <v-card class="mx-auto">
          <v-row>
            <v-col cols="3">
              <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" height="200px" style="margin-left: 1em;"/>
            </v-col>
            <v-col>
              <v-card-text>
                <div>Word of the Day</div>
                <p class="display-1 text--primary">
                  be•nev•o•lent
                </p>
                <p>adjective</p>
                <div class="text--primary">
                  well meaning and kindly.<br>
                  "a benevolent smile"
                </div>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-row>
    <v-row align="center" justify="center" style="padding-top: 10em;">
      <v-container>
        <v-card class="mx-auto">
          <v-row>
            <v-col>
              <v-card-text>
                <div>Word of the Day</div>
                <p class="display-1 text--primary">
                  be•nev•o•lent
                </p>
                <p>adjective</p>
                <div class="text--primary">
                  well meaning and kindly.<br>
                  "a benevolent smile"
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" height="200px" style="margin-right: 1em;"/>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      items: [
        {
          src: require('../assets/img/index-carousel/Carousel1.jpg'),
          title: "Learn Our Own Way",
          text: "Everyone learns in different ways",
        },
        {
          src: require('../assets/img/index-carousel/Carousel2.jpg'),
          title: "title",
          text: "boop",
        },
        {
          src: require('../assets/img/index-carousel/Carousel3.jpg'),
          title: "title",
          text: "boop",
        },
      ],
    }
    },
}
</script>

<style>
v-container
{
  margin-top: 100em;
}
</style>
